import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { AppsPageTabs } from 'src/features/apps'

import { WorkspacePageShell, useWorkspaceRoute } from './WorkspacePageShell'

type AppsLocationState = {
  openWorkspaceAppCreate?: boolean
}

export const WorkspaceAppsPage = () => {
  const { t } = useTranslation()
  const { workspaceId, idValid } = useWorkspaceRoute()
  const { state } = useLocation()
  const openCreateOnMount = Boolean(
    (state as AppsLocationState | null)?.openWorkspaceAppCreate
  )

  if (!idValid) {
    return null
  }

  return (
    <WorkspacePageShell
      sectionTitle={t('workspace.apps.title')}
      sectionDescription={t('workspace.apps.description')}
    >
      <AppsPageTabs
        key={`${workspaceId}-${JSON.stringify(state ?? null)}`}
        workspaceId={workspaceId}
        openCreateOnMount={openCreateOnMount}
      />
    </WorkspacePageShell>
  )
}
